export default {
  get: function(){
    return {
      details: null,
      fetching: false,
      error: false,
      success: false
    }
  }
}
